import Axios from "axios";

import {
    SET_PROJECT_CONTACT_LIST,
    UNSET_PROJECT_CONTACT_LIST,
  } from "@/store/mutation-types";
import { saveUpdateContact, getContactList } from "@/store/api";
// initial state
const state = {
  getContactList: [],
};

const getters = {
  getContactList(state) {
    return state.getContactList;
  },
};

const mutations = {
  [SET_PROJECT_CONTACT_LIST](state, data) {
    state.getContactList = data;
  },
  [UNSET_PROJECT_CONTACT_LIST](state) {
    state.getContactList = [];
  },

};

const actions = {

  saveUpdateContact({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateContact, data)
        .then(function (response) {
            resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getContactList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getContactList, data)
        .then(function (response) {
          commit('SET_PROJECT_CONTACT_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PROJECT_CONTACT_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};